import { render, staticRenderFns } from "./qqServe.vue?vue&type=template&id=7056c802&"
import script from "./qqServe.vue?vue&type=script&lang=js&"
export * from "./qqServe.vue?vue&type=script&lang=js&"
import style0 from "./qqServe.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports